<script setup>
import { onMounted, ref } from "vue";
import { useCarteleraStore } from "@/store/carteleraStore";
import Cartelera from "./Cartelera.vue";
import Destacadas from "./Destacadas.vue";
import BannerBajo from "./BannerBajo.vue";
import AlianzaComercial from "./AlianzaComercial.vue";
import SpinnerLoader from "@/components/Spinner/SpinnerLoader.vue";

const carteleraStore = useCarteleraStore();
const loading = ref(true);

onMounted(async () => {
  try {
    await Promise.all([
      carteleraStore.getSubastasDestacadas(),
      carteleraStore.getSubastas(),
      carteleraStore.getLotes(),
    ]);
  } finally {
    loading.value = false;
  }
});

</script>
<template>
  <div v-if="loading" class="spinner-overlay">
    <SpinnerLoader size="64px" />
  </div>
  <div class="mt-6 pt-1 pt-lg-0 mt-lg-0">
    <Destacadas :carteleraStore="carteleraStore" />
  </div>
  <div class="py-4 pt-0 container-fluid bg-soft-grey pe-md-0 ps-md-0">
    <div class="row">
      <Cartelera :carteleraStore="carteleraStore" />
    </div>
  </div>
  <BannerBajo />
  <AlianzaComercial />
</template>
